<template>
	
</template>

<script>
	export default {
		name: "BottleEdit"
	}
</script>

<style scoped>

</style>
